import PackageInfo from '../../../../package.json';
import { DynatraceClient } from '@workivate/tho-web-shared';
import { storageKeys } from 'globals/storage';

// Dynatrace stays off in production until its cookies are covered by Cookie Consent.
// Everywhere else it is enabled by default; set localStorage['dynatraceEnabled'] to
// 'false' to opt out.
export const isDynatraceEnabled = () =>
  !IS_PRODUCTION &&
  localStorage.getItem(storageKeys.dynatraceEnabled) !== 'false';

export const loadDynatraceScript = (url: string): Promise<void> => {
  return new Promise((resolve, reject) => {
    if (!url) {
      resolve();
      return;
    }
    if (document.querySelector(`script[src="${url}"]`)) {
      resolve();
      return;
    }
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.setAttribute('crossorigin', 'anonymous');
    script.src = url;
    script.onload = () => resolve();
    script.onerror = () =>
      reject(new Error(`Failed to load Dynatrace script: ${url}`));
    document.head.insertBefore(script, document.head.firstChild);
  });
};

export const initialiseDynatrace = () => {
  DynatraceClient.init({
    service: 'hermes',
    env: window.WAM.ENV.env === 'live' ? 'prod' : window.WAM.ENV.env,
    version: `${PackageInfo.version}_${window.WAM.ENV.env}`,
  });
};
